import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function workCardReducer(state = initialState.translationLoaded, action) {
    
    if (action.type === types.LOAD_TRANSLATIONS_SUCCESS)
    {
        return action.translationLoaded
    }
    else {
        return state;
    }
}
